// Number formatting rules are the same in LT, LV and EE
const currencyFormat = new Intl.NumberFormat("lt-LT", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  useGrouping: false,
});

const formatCurrency = (value: number): string => currencyFormat.format(value);
export default formatCurrency;
